import { render, staticRenderFns } from "./schoolFin.vue?vue&type=template&id=79afd6cf"
import script from "./schoolFin.vue?vue&type=script&lang=js"
export * from "./schoolFin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports